import { InfoCircleOutlined } from '@ant-design/icons';
import { Modal, Tooltip, Typography } from 'antd';
import { FC, ReactNode } from 'react';

import { BRAND_COLORS } from '../../../../../../constants/styles';
import { IMetricPeriodDetailsData } from '../../../types';
import { MetricPeriodSection } from '../MetricPeriodSection';

const { Title } = Typography;

interface IMetricDetailsModalProps {
  visible: boolean;
  onClose: () => void;
  data: IMetricPeriodDetailsData | null;

  title: string;
  tooltip: string;
  sectionLabel: string;
  headerValue: string;

  explainer: ReactNode;
  children: ReactNode;
  historySection: ReactNode;
}

export const MetricDetailsModal: FC<IMetricDetailsModalProps> = ({
  visible,
  onClose,
  data,
  title,
  tooltip,
  sectionLabel,
  headerValue,
  explainer,
  children,
  historySection,
}) => {
  if (!data) return null;

  return (
    <Modal
      visible={visible}
      onCancel={onClose}
      footer={null}
      title={
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <Title level={5} style={{ margin: 0 }}>
            {title}
          </Title>
          <Tooltip placement="bottomLeft" title={tooltip}>
            <InfoCircleOutlined
              style={{ color: BRAND_COLORS.secondary.lightGray, fontSize: 14 }}
            />
          </Tooltip>
        </div>
      }
      width={660}
      bodyStyle={{
        background: BRAND_COLORS.primary.deepNavy,
        padding: '20px 24px',
      }}
      destroyOnClose
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        {explainer}
        <MetricPeriodSection
          sectionLabel={sectionLabel}
          periodStart={data.periodStart}
          periodEnd={data.periodEnd}
          headerValue={headerValue}
          headerPeriodLabel={data.periodLabel}
          statusColor={data.statusColor}
          statusLabel={data.statusLabel}
        >
          {children}
        </MetricPeriodSection>
        {historySection}
      </div>
    </Modal>
  );
};
